export default __webpack_public_path__ + "static/media/Checkbox_unchecked.ee90a056.svg";